import { useEffect } from "react";
import { Loader2, ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";
import { GODADDY_DONATE_URL } from "@/lib/links";

export default function DonateRedirect() {
  useEffect(() => {
    api.post("/donate/click").catch(() => {}).finally(() => {
      window.location.replace(GODADDY_DONATE_URL);
    });
  }, []);

  return (
    <div className="min-h-screen bg-[#0A1128] text-white grain flex items-center justify-center px-5" data-testid="donate-redirect">
      <div className="relative z-10 text-center max-w-md">
        <ShieldCheck className="w-14 h-14 text-[#D90429] mx-auto" />
        <h1 className="font-display text-3xl uppercase mt-6">Taking You To Secure Donation</h1>
        <p className="text-white/60 mt-3 leading-relaxed">
          One moment while we send you to our secure payment page.
        </p>
        <Loader2 className="w-6 h-6 text-[#F4A261] animate-spin mx-auto mt-6" />
        <p className="text-white/40 text-sm mt-6">
          Not redirected?{" "}
          <a
            href={GODADDY_DONATE_URL}
            data-testid="donate-redirect-manual-link"
            className="text-[#F4A261] underline hover:text-white transition-colors duration-200"
          >
            Click here to donate
          </a>
        </p>
      </div>
    </div>
  );
}
